/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * 検索結果ページを商品名だけで検索する（【20261020】テスト）
 * 送信時に検索語を title:〇〇 に変換する。カテゴリ選択（PCのみ）は product_type:"〇〇" で絞り込む。
 * ※ 条件付きの検索になるため、誤字の補正・同義語・商品ブーストは効かない。
 */
(function () {
  function toTitleQuery(value) {
    return value.trim().split(/[\s　]+/).filter(Boolean).map(function (term) {
      var word = term.replace(/"/g, '');
      return /[:()\\]/.test(word) ? 'title:"' + word + '"' : 'title:' + word;
    }).join(' ');
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[action$="/search"]')) return;
    var input = form.querySelector('input[type="text"][name="q"], input[type="text"][data-c-search-input]');
    if (!input || input.value.trim() === '') return;

    // テーマ標準の送信処理（ヘッダー検索）を止めて、ここで q を組み立てる
    event.stopPropagation();

    var query = toTitleQuery(input.value);
    var typeSelect = form.querySelector('#search-product-type');
    if (typeSelect && typeSelect.value !== '') {
      query = 'product_type:"' + typeSelect.value.replace(/"/g, '') + '" AND ' + query;
    }

    var previous = form.querySelector('input[data-c-search-query]');
    if (previous) previous.remove();

    var hidden = document.createElement('input');
    hidden.setAttribute('data-c-search-query', '');
    hidden.type = 'hidden';
    hidden.name = 'q';
    hidden.value = query;
    input.setAttribute('data-c-search-input', '');
    input.removeAttribute('name');
    input.insertAdjacentElement('afterend', hidden);
  }, true);

  // 検索欄に検索語が残っている状態でフォーカスしたら、候補を読み込み直す
  document.addEventListener('focusin', function (event) {
    var input = event.target;
    if (!input.classList || !input.classList.contains('search-bar__input') || input.value === '') return;
    var results = document.querySelector('.search-bar__results-inner');
    if (results && results.innerHTML.trim() === '') {
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  });
})();
